var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    clipPath: "url(#clip-dashboard)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(-44.748 -363.499)",
    opacity: 0.998
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(45.5 370.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(17.666 10.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M64.1,376.024l-8.947,7.866-.033.031a1.529,1.529,0,0,0,1.078,2.612,1.553,1.553,0,0,0,1.115-.484l7.866-8.947a.765.765,0,0,0-1.08-1.078Z",
    transform: "translate(-54.667 -375.833)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M64.5,370.833c-10.477,0-19,8.8-19,19.624a20.184,20.184,0,0,0,.9,5.974.8.8,0,0,0,.754.569H81.843a.8.8,0,0,0,.754-.569,20.185,20.185,0,0,0,.9-5.974C83.5,379.636,74.977,370.833,64.5,370.833Zm15.042,20.442h2.32a18.417,18.417,0,0,1-.608,4.088H47.746a18.419,18.419,0,0,1-.608-4.088h2.32a.818.818,0,0,0,0-1.635H47.123a18.342,18.342,0,0,1,1.927-7.453l2.027,1.211a.774.774,0,0,0,.4.11.783.783,0,0,0,.684-.41.831.831,0,0,0-.289-1.117l-2.024-1.207a17.837,17.837,0,0,1,5.28-5.453l1.168,2.092a.788.788,0,0,0,.686.408.774.774,0,0,0,.4-.11.831.831,0,0,0,.289-1.117l-1.17-2.1a16.844,16.844,0,0,1,7.214-1.988v2.412a.793.793,0,1,0,1.585,0v-2.412a16.844,16.844,0,0,1,7.214,1.988l-1.17,2.1a.831.831,0,0,0,.289,1.117.774.774,0,0,0,.4.11.788.788,0,0,0,.686-.408l1.169-2.092a17.837,17.837,0,0,1,5.28,5.453l-2.024,1.207a.831.831,0,0,0-.289,1.117.783.783,0,0,0,.684.41.774.774,0,0,0,.4-.11l2.027-1.211a18.343,18.343,0,0,1,1.927,7.453H79.542a.818.818,0,0,0,0,1.635Z",
    transform: "translate(-45.5 -370.833)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.814568e96faef8d1ec7c74218dbe6f54.svg";
export { ForwardRef as ReactComponent };